module.exports = __webpack_public_path__ + "img/dsama_icon.7ac81faf.png";